$(function() {
  // --- 既存のコード（ヘッダー調整・カレンダー・検索・ハンバーガーメニュー等） ---
  headerAdjust();
  // スクロールハンドラは requestAnimationFrame でスロットリング。passive: true で
  // scroll listener がスクロールをブロックしないようにする(モバイル性能改善)。
  var _headerAdjustTicking = false;
  window.addEventListener('scroll', function() {
    if (_headerAdjustTicking) return;
    _headerAdjustTicking = true;
    window.requestAnimationFrame(function() {
      headerAdjust();
      _headerAdjustTicking = false;
    });
  }, { passive: true });
  $('.day-list').each(function() {
      var month = $(this).attr('data-month');
      var day = $(this).attr('data-day');
      var color = $(this).attr('data-color');
      $('.makeshop-calendar' + month +' .day' + day).css({
          'background-color': color,
          'color': '#fff',
          'font-weight': 'bold',
          'height': '14px'
      });
  });
  $('.openbtn').on('click', function() {
      $(this).toggleClass('active');
      $('#g-nav').toggleClass('panelactive');
  });
  // 検索トグル(クリックで開閉)
  $('.header-search-toggle').on('click', function(e) {
      e.stopPropagation(); // クリックアウェイハンドラの巻き込みを防ぐ
      $('.header-search-mobile').toggleClass('active');
      if ($('.header-search-mobile').hasClass('active')) {
          $('.header-search-mobile .header-search-input').focus();
      }
  });
  // クリックアウェイで検索バーを閉じる
  $(document).on('click', function(e) {
      var $bar = $('.header-search-mobile');
      if (!$bar.hasClass('active')) return;
      if ($bar.is(e.target) || $bar.has(e.target).length) return;
      $bar.removeClass('active');
  });
  // ESC キーで検索バーを閉じる
  $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $('.header-search-mobile').hasClass('active')) {
          $('.header-search-mobile').removeClass('active');
      }
  });
  $('#g-nav a').on('click', function() {
      $('.openbtn').removeClass('active');
      $('#g-nav').removeClass('panelactive');
  });
  $('.accordion').on('click', function() {
      $(this).toggleClass('on').next().slideToggle();
      $('.accordion').not(this).removeClass('on').next('.close').slideUp();
  });

  // === イベント管理 ===
  // v5.20: イベント情報は sections/events.liquid で管理（Theme Editor から GUI 編集可能）。
  //         common.js では Swiper 初期化のみ担当。

  // キャッシュ済み画像は即座に表示（Liquid で出力されたグリッド画像用）
  var eventGrid = document.getElementById('event-grid');
  if (eventGrid) {
    var gridImgs = eventGrid.querySelectorAll('img');
    for (var i = 0; i < gridImgs.length; i++) {
      if (gridImgs[i].complete) gridImgs[i].classList.add('loaded');
    }
  }

  // メインスライダーの初期化（トップページのみ）
  if (typeof Swiper !== 'undefined' && document.querySelector('.main-swiper')) {
    const swiper = new Swiper(".main-swiper", {
      loop: true,
      slidesPerView: 'auto', // CSS幅に基づく自動表示数調整
      centeredSlides: true,
      spaceBetween: 10, // スライド間のスペース
      speed: 800,

      // 自動再生の設定
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      // エフェクト設定
      effect: 'slide',

      // ナビゲーションボタン
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },

      // ページネーション(装飾専用: 現在位置インジケータ)
      // - clickable を切ることで bullets を focusable/tappable から外し、
      //   WCAG 2.5.5 の小さすぎるタップターゲット警告を回避。
      //   スライド操作は prev/next ボタン(44x44)と swipe ジェスチャで代替可能。
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
        dynamicBullets: true,
      },

      // キーボード操作対応
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // レスポンシブ時の挙動改善
      observer: true,
      observeParents: true,

      // ファーストビュー画像は即時読み込み（遅延読み込み無効）
      preloadImages: true,

      // アクセシビリティ対応
      a11y: {
        enabled: true,
        prevSlideMessage: '前のスライド',
        nextSlideMessage: '次のスライド',
        paginationBulletMessage: 'スライド {{index}} に移動',
      },
    });
    // パフォーマンス最適化：Intersection Observer
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            swiper.autoplay.start();
          } else {
            swiper.autoplay.stop();
          }
        });
      });
      const swiperElement = document.querySelector('.main-swiper');
      if (swiperElement) {
        observer.observe(swiperElement);
      }
    }
  }


});

// --- 既存のグローバル関数 ---
function headerAdjust() {
    var adjustPoint = 20;
    var scrollTop = $(window).scrollTop();
    if(scrollTop > adjustPoint) {
        $('.header').addClass('fix');
    } else {
        $('.header').removeClass('fix');
    }
}

function MakeShop_afterListCartEntry(data){
    if (!data.result) {
        if (data.method && data.method.modal) {
            data.method.modal(data.error.message, function() {
                location.href = '/view/item/' + data.systemCode;
            });
        }
        return false;
    }

    // カートバッジ更新
    var cartBadge = document.querySelector('.cart-badge');
    if (cartBadge) {
        cartBadge.textContent = data.totalQuantity;
        cartBadge.style.display = 'block';
    }

    // トースト通知表示
    showCartToast(data.totalQuantity);

    return false;
}

function showCartToast(totalQuantity) {
    // 既存のトーストがあれば削除
    var existing = document.getElementById('cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'cart-toast';
    toast.innerHTML =
        '<div class="cart-toast-inner">' +
            '<div class="cart-toast-icon-row">' +
                '<div class="cart-toast-check">\u2713</div>' +
                '<p class="cart-toast-message">カートに追加しました</p>' +
            '</div>' +
            '<p class="cart-toast-count">カート内: ' + totalQuantity + '点</p>' +
            '<div class="cart-toast-actions">' +
                '<a href="/view/cart" class="cart-toast-btn cart-toast-btn--view">カートを見る</a>' +
                '<button type="button" class="cart-toast-btn cart-toast-btn--close">買い物を続ける</button>' +
            '</div>' +
        '</div>';
    document.body.appendChild(toast);

    // 「買い物を続ける」ボタン
    toast.querySelector('.cart-toast-btn--close').addEventListener('click', function() {
        toast.classList.remove('cart-toast--show');
        setTimeout(function() { toast.remove(); }, 300);
    });

    // 表示アニメーション（double RAF: 初期スタイル描画後にクラスを追加してトランジションを確実に発火）
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            toast.classList.add('cart-toast--show');
        });
    });

    // 5秒後に自動非表示
    setTimeout(function() {
        if (document.getElementById('cart-toast')) {
            toast.classList.remove('cart-toast--show');
            setTimeout(function() { toast.remove(); }, 300);
        }
    }, 5000);
}

// ページネーション省略処理
// 表示: ‹ 1 ... [current-2] [current-1] [current] [current+1] [current+2] ... last ›
(function() {
  var pagers = document.querySelectorAll('.pager');
  if (!pagers.length) return;

  pagers.forEach(function(pager) {
    var items = Array.from(pager.children);
    // prev/nextを除いた数字liだけ抽出
    var numberItems = [];
    var prevItem = null;
    var nextItem = null;

    items.forEach(function(li) {
      var prev = li.querySelector('.prev');
      var next = li.querySelector('.next');
      if (prev) { prevItem = li; }
      else if (next) { nextItem = li; }
      else { numberItems.push(li); }
    });

    // 7ページ以下なら省略不要
    if (numberItems.length <= 7) return;

    // 現在ページのインデックスを特定
    var currentIdx = -1;
    numberItems.forEach(function(li, i) {
      if (li.querySelector('.current')) currentIdx = i;
    });
    if (currentIdx === -1) return;

    var total = numberItems.length;
    var lastIdx = total - 1;

    // 表示するインデックスを決定: 先頭, 末尾, current前後2つ
    var visible = new Set();
    visible.add(0);
    visible.add(lastIdx);
    for (var i = currentIdx - 2; i <= currentIdx + 2; i++) {
      if (i >= 0 && i <= lastIdx) visible.add(i);
    }

    // 省略記号のli要素を作成
    function createEllipsis() {
      var li = document.createElement('li');
      var span = document.createElement('span');
      span.className = 'pager-ellipsis';
      span.textContent = '...';
      li.appendChild(span);
      return li;
    }

    // 新しい順序で再構築
    var fragment = document.createDocumentFragment();
    if (prevItem) fragment.appendChild(prevItem);

    var sortedVisible = Array.from(visible).sort(function(a, b) { return a - b; });
    var prevIdx = -1;
    sortedVisible.forEach(function(idx) {
      if (prevIdx !== -1 && idx - prevIdx > 1) {
        fragment.appendChild(createEllipsis());
      }
      fragment.appendChild(numberItems[idx]);
      prevIdx = idx;
    });

    if (nextItem) fragment.appendChild(nextItem);

    // 残りの非表示liを削除してから再構築
    while (pager.firstChild) pager.removeChild(pager.firstChild);
    pager.appendChild(fragment);
  });
})();